import React from 'react';
import './../index.css';
import ReactPlayer from "react-player"
import thumb from '../../src/images/alliance_thumbnail.png'

export class LevelVideos extends React.Component {

  render() {
    const videos = this.props.videos;
    return (
      <>
        {
          /*
          * Level Video section
          */
        }
        {videos &&
          <div className='levelVideos'>
            {
              videos.map(

                currentVideo =>
                  <div key={currentVideo.text}>
                    {currentVideo.text}
                    <ReactPlayer
                      config={{
                        youtube: {
                          playerVars: { controls: 1, autoplay: 1, playsinline: 1, showinfo: 0, allowsInlinePlayback: true }
                        }
                      }}
                      playsinline
                      width='30vw'
                      height='20vw'
                      className='levelVideoPlayer'
                      controls
                      light={thumb}
                      url={currentVideo.url}
                    />
                  </div>
              )
            }
          </div>

        }
      </>
    );
  }


}
